module.exports = __webpack_public_path__ + "images/logo-env_stage2.svg?e8602ca9e87f124a2e08673d96f3b18c";